<template>
  <div>
    <div>
      <h1>
        Web Question <span v-if="mode === 'add'">Add</span>
        <span v-if="mode === 'edit'">Edit</span>
      </h1>
    </div>

    <div><h3>Question Info</h3></div>
    <div class="row coding-row">
      <div class="small-2 columns"><div class="coding-label">Name</div></div>
      <div class="small-10 columns">
        <input v-model="codingObject.name" type="text" />
      </div>
    </div>
    <!--  -->
    <div v-if="mode === 'edit'" class="row coding-row">
      <div class="small-2 columns"><div class="coding-label">ID</div></div>
      <div class="small-10 columns">
        <strong class="coding-label">{{ codingObject.id }}</strong>
      </div>
    </div>
    <!--  -->
    <!--  -->
    <div class="row coding-row">
      <div class="small-2 columns"><div class="coding-label">CMS ID</div></div>
      <div class="small-10 columns">
        <input v-model="codingObject.cms_id" type="text" />
      </div>
    </div>
    <div
      v-if="
        codingObject &&
          codingObject.cms_metadata &&
          codingObject.cms_metadata.admin_data
      "
      class="row coding-row"
    >
      <div class="small-2 columns"><div class="coding-label">CMS URL</div></div>
      <div class="small-10 columns">
        <a :href="codingObject.cms_metadata.admin_data.url">{{
          codingObject.cms_metadata.admin_data.url
        }}</a>
      </div>
    </div>
    <!--  -->
    <div class="row coding-row">
      <div class="small-2 columns"><div class="coding-label">Points</div></div>
      <div class="small-10 columns">
        <input v-model="codingObject.points" type="text" />
      </div>
    </div>
    <!--  -->
    <div class="row coding-row">
      <div class="small-2 columns"><div class="coding-label">Tags</div></div>
      <div class="small-10 columns">
        <VueSelect
          v-model="selectedTags"
          :options="tagOptions"
          label="name"
          multiple
        />
      </div>
    </div>
    <div class="row coding-row">
      <label
        for="time-bound"
        class="coding-label small-2 columns cursor-pointer"
        >Is Time Bound?
      </label>
      <input
        id="time-bound"
        v-model="codingObject.is_time_bound"
        name="time-bound"
        type="checkbox"
        style="position:relative;top:5px;width:20px;margin:0;"
      />
    </div>
    <!--  -->
    <div class="row coding-row">
      <div class="small-2 columns">
        <div class="coding-label">Time Allocated</div>
      </div>
      <div class="small-10 columns">
        <input v-model="codingObject.time_allocated" type="text" />
      </div>
    </div>
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <div class="row border-b mb-8">
      <h2 class="text-center my-4 border-b pb-4">Notes/Instructions</h2>
      <div class="small-6 columns">
        <h4 class="text-center mb-2">Input</h4>
        <MarkdownReadingEditor
          v-model="codingObject.content"
          @imageAdded="catchImageAddedEvent"
        />
      </div>
      <div class="small-6 columns pl-4 mb-4">
        <h4 class="text-center mb-2">Output</h4>
        <div class="mcq-content-rendered-markdown" />
        <VueMarkdown :source="getRenderedMarkdownToHTML()" />
      </div>
    </div>

    <div class="row">
      <div class="small-12 columns text-center">
        <div>
          <h3>Languages ({{ languageArray.length }} enabled)</h3>
        </div>
      </div>
      <div v-for="(item, i) in languageArray" :key="i" class="small-12 columns">
        <LanguageItem
          :languages="languages"
          :index="i"
          :item="item"
          :hasTemplate="false"
          @OPEN_MODAL_CONTENT="toggleModal"
        />
        <div class="text-right">
          <button
            class="remove-language-class p-2 px-4 border border-grey hover:bg-red-dark hover:text-white hover:border-red-darker"
            @click="removeLanguageArray(i)"
          >
            - remove language
          </button>
        </div>
      </div>
      <div v-if="languageArray.length < 3" class="text-center">
        <button
          class="add-language-class border border-green p-2 px-4 hover:bg-green-light hover:text-white"
          @click="addToLanguageArray"
        >
          + Add Language
        </button>
      </div>
    </div>
    <!--  -->
    <div class="small-12 columns">
      <div><h2 class="text-center my-2">Mocha Test file</h2></div>
    </div>
    <div class="row">
      <div class="small-test-cases-container">
        <div class="row">
          <div class="small-4 columns">
            <div class="coding-label">
              Mocha test file
              <div
                v-if="codingObject.test_case_file_input_id.length > 2"
                @click="toggleModal(codingObject.test_case_file_input_id)"
              >
                <strong>File ID:</strong>
                <span class="link">
                  {{ codingObject.test_case_file_input_id }}
                </span>
              </div>
            </div>
          </div>
          <div class="small-8 columns">
            <CodeSingleFileUpload
              :maxFileSize="maxFileSize"
              @codingFileUploadFail="handleFileUploadFailure"
              @codingFileUploadSuccess="handleSmallInEvent($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div>
      <div class="block text-center m-auto my-8 font-normal">
        <div class="mb-4">
          <button
            class="border border-grey-darkest p-2 px-4"
            @click="initiateWebEditor"
          >
            Test in web workspace below
          </button>
        </div>
        <button
          class="border border-grey-darkest p-2 px-4"
          @click="spitCodeJSON"
        >
          <span v-if="mode === 'add'">Add</span>
          <span v-if="mode === 'edit'">Update Question</span>
        </button>
      </div>
    </div>
    <VModal
      name="test-web-question"
      :click-to-close="true"
      width="98%"
      height="98%"
      :pivotY="0.1"
      style="overflow: auto; transform: translateZ(0);"
    >
      <div class="workspace p-4 overflow-auto">
        <WebEditor
          :langList="languageArray"
          :question="codingObject"
          :hasHTML="hasHTML"
          :hasCSS="hasCSS"
          :hasJavaScript="hasJavaScript"
          :testCasesStatus="testCasesStatus"
          :unitTestAsString="mochaTestString"
          @UPDATE_TEST_CASE_STATUS="updateTestCaseStatus"
        />
      </div>
      <div class="test-result">
        <p
          v-if="testCasesStatus === 'PASSED'"
          class="text-center text-green mb-4"
        >
          All test cases passed.
        </p>
      </div>
      <div class="text-center mb-8">
        <button
          class="border border-grey-darkest p-2 px-4"
          @click="$modal.hide('test-web-question')"
        >
          Close
        </button>
      </div>
    </VModal>
    <!--  -->
    <div>
      <SweetModal ref="rawcontentmodal" width="80%" @closed="modalOpen = false">
        <pre>{{ modalContent }}</pre>
      </SweetModal>
    </div>
    <!--  -->
  </div>
</template>

<script>
/**
 * This is a new component that takes care of converting the coding question object to UI format and back
 * again. The other two components you see... CodingAdd, CodingEdit are legacy components,
 * preserved for the sake of reference
 */
import { SweetModal } from "sweet-modal-vue"
import VueSelect from "vue-select"
import WebEditor from "@edyst/shared-components/src/components/WebEditor"
import VueMarkdown from "vue-markdown"
import MarkdownReadingEditor from "@/components/questions/MarkdownReadingEditor"
import CodeSingleFileUpload from "@/components/shared/fileUpload/SingleFileUpload"
import LanguageItem from "@/components/coding/CodeComponents/LanguageItem"
import markdownHelpers from "@/utils/markdownEditorHelpers"

import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    LanguageItem,
    CodeSingleFileUpload,
    VueSelect,
    MarkdownReadingEditor,
    SweetModal,
    WebEditor,
    VueMarkdown,
  },
  props: ["codingObject", "mode"],
  data() {
    return {
      shouldRunTest: false,
      testCasesStatus: "",
      languageArray: [],
      testCaseArray: [],
      languages: [],
      tagOptions: [],
      selectedTags: [],
      markdownRenderer: undefined,
      // nginx default POST client payload size is 1MB
      // we are limiting upload to about 800KB here
      maxFileSize: 800 * 1024,
      modalOpen: false,
      modalContent: "",
      mochaTestString: "",
    }
  },
  computed: {
    hasHTML() {
      return this.hasLanguage(this.languageArray, "html")
    },
    hasCSS() {
      return this.hasLanguage(this.languageArray, "css")
    },
    hasJavaScript() {
      return this.hasLanguage(this.languageArray, "javascript")
    },
  },
  created() {
    this.markdownRenderer = window.markdownit()
    this.getLanguages()
    this.populateTags()

    this.populateLanguageArray()
    this.populateTestCaseArray()
  },
  methods: {
    getRenderedMarkdownToHTML() {
      return this.markdownRenderer.render(
        markdownHelpers.decodeIDsToMarkdownLinks(
          this.codingObject.content,
          this.codingObject.attachments
        )
      )
    },
    initiateWebEditor() {
      this.fetchTestFileContent(
        this.codingObject.test_case_file_input_id,
        false
      )
    },
    hasLanguage(langArr, language) {
      return langArr.find(item => item.language.toLowerCase() === language)
    },
    updateTestCaseStatus(status) {
      this.testCasesStatus = status
    },
    toggleModal(id) {
      this.fetchTestFileContent(id, true)
    },
    fetchTestFileContent(id, showPreviewInModal) {
      const loader = this.$loading.show()
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}uploads/${id}?fetch_data=1`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.modalContent = res.data.data.data
          // remove the keyword
          this.mochaTestString = res.data.data.data.replace("ED$%$ED", "")
          if (showPreviewInModal) {
            if (this.modalOpen) {
              this.$refs.rawcontentmodal.close()
            } else {
              this.$refs.rawcontentmodal.open()
            }
          } else {
            this.$modal.show("test-web-question")
          }
          loader.hide()
        })
        .catch(err => {
          console.error(err)
          loader.hide()
        })
    },

    validationCheck() {
      if (this.codingObject.name.length < 2) {
        alert("Please choose a valid name")
        return false
      }
      if (this.codingObject.name.points < 0) {
        alert("Please enter valid points")
        return false
      }
      if (this.codingObject.content.length < 2) {
        alert("Please try again after entering some content")
        return false
      }

      if (this.languageArray.length === 0) {
        alert("Please add atleast one language section")
        return false
      }

      for (let i = 0; i < this.languageArray.length; i++) {
        if (!this.languageArray[i].language) {
          alert("please choose a valid language in languages section")
          return false
        }
      }

      // For SQL questions, test case (Run) files are optional
      let allow_no_test_case_files = false
      const codeTemplate = this.codingObject.code_template_file_json.data
      for (let j = 0; j < codeTemplate.length; j++) {
        if (codeTemplate[j].language.startsWith("SQL")) {
          allow_no_test_case_files = true
        }
      }

      if (!allow_no_test_case_files) {
        if (this.codingObject.test_case_file_input_id.length < 7) {
          alert("please choose a test case input file")
          return false
        }
      }
      return true
    },
    populateTestCaseArray() {
      const arr = this.codingObject.submission_cases
      if (JSON.stringify(arr) === "{}") {
        this.testCaseArray = []
        return
      }
      this.testCaseArray = this.codingObject.submission_cases
    },
    populateLanguageArray() {
      const placeholderJSON = this.codingObject.placeholder_json.data

      for (let i = 0; i < placeholderJSON.length; i++) {
        const codeTemplate = this.codingObject.code_template_file_json.data
        for (let j = 0; j < codeTemplate.length; j++) {
          if (placeholderJSON[i].language === codeTemplate[j].language) {
            this.languageArray.push({
              language: placeholderJSON[i].language,
              template: codeTemplate[j].code_template_file_id,
              placeholder: placeholderJSON[i].placeholder,
            })
          }
        }
      }
    },
    spitCodeJSON() {
      this.codingObject.code_template_file_json.data = this.getCodeTemplateFileJSONFormat()

      if (!this.validationCheck()) {
        return
      }
      this.codingObject.ops_qtags_unlink = this.getDeletedTags()
      this.codingObject.ops_qtags = this.getAddedTags()

      /**
       * Rewrite the titles, just incase the middle elements have been deleted and the order is lost.
       */

      for (let i = 0; i < this.testCaseArray.length; i++) {
        this.testCaseArray[i].title = `Test Case ${i + 1}`
      }

      this.codingObject.submission_cases = this.testCaseArray
      this.codingObject.placeholder_json.data = this.getPlaceholderJSONFormat()

      this.codingObject.template_code_folding_state = this.codingObject
        .template_code_folding_state
        ? parseInt(this.codingObject.template_code_folding_state)
        : 0

      this.$emit("CODING_OBJECT_EMITTED", this.codingObject)
    },
    getCodeTemplateFileJSONFormat() {
      const arr = []
      for (let i = 0; i < this.languageArray.length; i++) {
        const obj = {}

        obj.language = this.languageArray[i].language
        obj.code_template_file_id = this.languageArray[i].template
        arr.push(obj)
      }

      return arr
    },
    getPlaceholderJSONFormat() {
      const arr = []
      for (let i = 0; i < this.languageArray.length; i++) {
        const obj = {}

        obj.jz_code = this.getJZCode(this.languageArray[i].language)
        obj.language = this.languageArray[i].language
        obj.placeholder = this.languageArray[i].placeholder
        arr.push(obj)
      }

      return arr
    },

    getJZCode(language) {
      for (let i = 0; i < this.languages.length; i++) {
        if (this.languages[i].name === language) {
          return this.languages[i].jz_code
        }
      }
      throw new Error("no valid jzcode")
    },
    populateTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/?pagination=false&sort_by=-updated_on`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        const tags = res.data.items
        this.tagOptions = tags.map(item => ({
          id: item.id,
          name: item.name,
        }))
      })

      this.selectedTags = this.codingObject.qtags.map(item => ({
        id: item.id,
        name: item.name,
      }))
    },
    handleFileUploadFailure(message) {
      alert(`File upload failed! ${message}`)
    },
    handleSmallInEvent(event) {
      console.log(event)
      this.codingObject.test_case_file_input_id = event.id
    },
    handleSmallOutEvent(event) {
      this.codingObject.test_case_file_output_id = event.id
    },
    removeTestCase(i) {
      this.testCaseArray.splice(i, 1)
    },

    addToLanguageArray() {
      this.languageArray.push({
        language: "",
        template: "",
        placeholder: "",
      })
    },
    removeLanguageArray(i) {
      this.languageArray.splice(i, 1)
    },
    getLanguages() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}languages/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.languages = res.data.items.filter(
            lang =>
              lang.name === "HTML" ||
              lang.name === "CSS" ||
              lang.name === "Javascript"
          )
        })
        .catch(err => console.error("failed to get the languages", err))
    },
    getDeletedTags() {
      const deletedTags = []
      for (let i = 0; i < this.codingObject.qtags.length; i++) {
        if (
          !this.findElementInArray(
            this.codingObject.qtags[i].name,
            this.selectedTags.map(item => item.name)
          )
        ) {
          deletedTags.push(this.codingObject.qtags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < deletedTags.length; i++) {
        finalTags.push(deletedTags[i].id)
      }
      return finalTags
    },
    getAddedTags() {
      const addedTags = []

      for (let i = 0; i < this.selectedTags.length; i++) {
        if (
          !this.findElementInArray(
            this.selectedTags[i].name,
            this.codingObject.qtags.map(item => item.name)
          )
        ) {
          addedTags.push(this.selectedTags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < addedTags.length; i++) {
        finalTags.push(addedTags[i].id)
      }
      return finalTags
    },
    findElementInArray(element, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === element) {
          return true
        }
      }
      return false
    },
    catchImageAddedEvent(eventObj) {
      this.content = eventObj.encodedString
      for (let i = 0; i < eventObj.attachments.length; i++) {
        this.codingObject.attachments.push(eventObj.attachments[i])
      }
    },
  },
}
</script>

<style scoped>
.columns > input {
  padding: 10px;
}

.add-language-class {
  margin: 20px;
  color: green;
  text-align: left;
  cursor: pointer;
}

.remove-language-class {
  margin: 20px;
  color: red;
  text-align: right;
  cursor: pointer;
}

.coding-label {
  padding-right: 40px;
  font-weight: 500;
  line-height: 1.5;
  text-align: right;
}

.coding-row {
  margin-top: 20px;
  margin-bottom: 20px;
}

div > strong {
  color: blue;
}
.small-test-cases-container {
  padding-top: 60px;
  padding-bottom: 60px;
  border: 1px solid grey;
  background-color: #f9f9f9;
}
</style>

<style>
.v--modal-overlay .v--modal-box {
  overflow: auto !important;
  top: 1rem;
}
</style>
